export default __webpack_public_path__ + "static/media/solar_panels.d7d441d7.jpeg";